import { cn } from "@/lib/utils";
import * as React from "react";

const FunctionalCard = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "tw-rounded-8 tw-border tw-border-gray-300 tw-bg-base-white tw-w-full tw-flex tw-flex-col",
      className,
    )}
    {...props}
  />
));
FunctionalCard.displayName = "FunctionalCard";

export type FunctionalCardHeaderProps = React.HTMLAttributes<HTMLDivElement> & {
  closeButton?: React.ReactNode;
  closeButtonClasses?: string;
};

const FunctionalCardHeader = React.forwardRef<
  HTMLDivElement,
  FunctionalCardHeaderProps
>(({ className, closeButton, children, closeButtonClasses, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "tw-flex tw-py-12 tw-px-16 tw-border-b tw-border-gray-300 tw-relative",
      className,
    )}
    {...props}
  >
    <div
      className={cn("tw-relative tw-z-40",  closeButtonClasses, {
        "tw-pr-28": !!closeButton,
      })}
    >
      {children}
    </div>
    {closeButton && (
      <div className="tw-absolute tw-right-16 tw-top-0 tw-bottom-0 tw-z-50 tw-flex tw-items-center tw-justify-center">
        {closeButton}
      </div>
    )}
  </div>
));
FunctionalCardHeader.displayName = "FunctionalCardHeader";

const FunctionalCardTitle = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn("tw-headline-1-m tw-text-gray-900 tw-m-0", className)}
    {...props}
  />
));
FunctionalCardTitle.displayName = "FunctionalCardTitle";

const FunctionalCardDescription = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("tw-body-2 tw-text-gray-600", className)}
    {...props}
  />
));
FunctionalCardDescription.displayName = "FunctionalCardDescription";

const FunctionalCardContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("tw-body-1-long tw-text-gray-600 tw-m-0 tw-p-16", className)}
    {...props}
  />
));
FunctionalCardContent.displayName = "FunctionalCardContent";

const FunctionalCardFooter = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "tw-flex tw-py-12 tw-px-16 tw-border-t tw-border-gray-300",
      className,
    )}
    {...props}
  />
));
FunctionalCardFooter.displayName = "FunctionalCardFooter";

export {
  FunctionalCard,
  FunctionalCardContent,
  FunctionalCardDescription,
  FunctionalCardFooter,
  FunctionalCardHeader,
  FunctionalCardTitle,
};
